import { SETUP } from './setup';
import { MODULES_PEOPLE } from './modulesPeople';
import { MODULES_OPS } from './modulesOps';
import { MODULES_ENTERPRISE } from './modulesEnterprise';
import { WORKFLOWS } from './workflows';
import { REFERENCE } from './reference';

export const CATEGORIES = [
  { key: 'setup', label: 'Setup & configuration' },
  { key: 'modules', label: 'Module guides' },
  { key: 'workflows', label: 'Workflows (end to end)' },
  { key: 'reference', label: 'Reference' },
];

export function allArticles(API) {
  return [...SETUP, ...MODULES_PEOPLE, ...MODULES_OPS, ...MODULES_ENTERPRISE, ...WORKFLOWS, ...REFERENCE(API)];
}

// Maps an app route to the doc article that explains it (used by the in-module Help button).
export const DOC_FOR_ROUTE = {
  '/': 'm-dashboard',
  '/students': 'm-students',
  '/admissions': 'm-admissions',
  '/directory': 'm-directory',
  '/hr': 'm-hr',
  '/alumni': 'm-alumni',
  '/advancement': 'm-advancement',
  '/academics': 'm-academics',
  '/academic-core': 'm-academic-core',
  '/advisor': 'm-advisor',
  '/register': 'm-course-registration',
  '/registration-desk': 'm-registration-desk',
  '/gradebook': 'm-gradebook',
  '/attendance': 'm-attendance',
  '/exams': 'm-exams',
  '/library': 'm-library',
  '/lms': 'm-lms',
  '/university': 'm-university',
  '/onboarding': 'm-onboarding',
  '/fees': 'm-fees',
  '/reconciliation': 'm-reconciliation',
  '/operations': 'm-operations',
  '/assets': 'm-assets',
  '/procurement': 'm-procurement',
  '/transport': 'm-transport',
  '/cctv': 'm-cctv',
  '/bgv': 'm-bgv',
  '/events': 'm-events',
  '/health': 'm-health',
  '/hostel': 'm-hostel',
  '/chat': 'm-chat',
  '/comms': 'm-comms',
  '/announcements': 'm-announcements',
  '/automation': 'm-automation',
  '/integrations': 'm-integrations',
  '/admin': 'm-admin',
  '/iam': 'm-iam',
  '/lifecycle': 'm-lifecycle',
  '/nhi': 'm-nhi',
  '/itops': 'm-itops',
  '/itsm': 'm-itsm',
  '/directory-sync': 'm-dirsync',
  '/identity-graph': 'm-identity-graph',
  '/insights': 'm-insights',
  '/reports': 'm-reports',
};

export function docForPath(pathname) {
  if (DOC_FOR_ROUTE[pathname]) return DOC_FOR_ROUTE[pathname];
  if (/^\/students\/[^/]+$/.test(pathname)) return 'm-students';
  return null;
}

function blockText(b) {
  if (b.p) return b.p; if (b.h) return b.h; if (b.callout) return b.callout; if (b.code) return b.code;
  if (b.list) return b.list.join(' '); if (b.steps) return b.steps.join(' ');
  if (b.kv) return b.kv.map((x) => x.join(' ')).join(' ');
  if (b.table) return [b.table.cols.join(' '), ...b.table.rows.map((r) => r.join(' '))].join(' ');
  return '';
}

export function searchArticles(articles, q) {
  const needle = q.trim().toLowerCase();
  if (!needle) return [];
  return articles.map((a) => {
    const hay = `${a.title} ${a.summary} ${a.blocks.map(blockText).join(' ')}`.toLowerCase();
    const idx = hay.indexOf(needle);
    if (idx === -1) return null;
    const plain = `${a.title} ${a.summary} ${a.blocks.map(blockText).join(' ')}`;
    const snippet = plain.slice(Math.max(0, idx - 40), idx + 90).replace(/\*\*/g, '');
    return { article: a, snippet };
  }).filter(Boolean);
}
